module.exports = __webpack_public_path__ + "static/media/aster_home.3454bf32.png";